// import intersectionObserver from './intersectionObserver';
// import {SwiperRew, SwiperStat } from "./sliders";
// import intersectionObserver from "@/intersectionObserver";
// import {XS, XL, XXL} from '@p/card3d'
// import axios from "axios";
// import barba from "@l/barbav2";
// import {checkScrollSpeed} from '@p/detect-speed-scroll'
// import {textCode} from '@p/text-code'
// import select from './select'
//import { Sections } from "@p/navbar";
import barba from '@barba/core';
import { basket } from './basket';
import { start_update_price } from './online-price';
import { phoneMask } from "@l/input-mask";
import { ZayavkaO } from "./zayavka-open";
import { SearchModel } from "./search";
// import { textCode } from './custom-plugin/text-code';

function addViews() {
  if (!$(".v-count")) return;
  var id = $(".v-count").textContent;
  axios.post("/add-views", {
    id: id
  })["catch"](function (r) {
    return cPush.show({
      title: "Ошибка загрузки"
    });
  });
  //.then((r) =>console.log('views refresh!'))
}
function modelFilter() {
  var arrModels = [];
  if (!$('.card__list__filtred')) return;
  $('.card__list__filtred').querySelectorAll('.card__item').forEach(function (elem) {
    arrModels.push(elem);
  });
  $('.models_filter').oninput = function (e) {
    var count = 0;
    $('.card__list__filtred').innerHTML = '';
    var inputText = $('.models_filter').value.trim().toUpperCase();
    arrModels.forEach(function (elem) {
      var title = elem.querySelector('.card__item__text').textContent.trim().toUpperCase();
      if (title.includes(inputText)) {
        count++;
        $('.card__list__filtred').appendChild(elem);
      }
    });
  };
}
function blogSearch() {
  if (!$('.blog__search')) return;
  var arrArticle = [];
  $$('.stat__preview__item').forEach(function (elem) {
    arrArticle.push(elem);
  });
  $('.blog__search').oninput = function (e) {
    var count = 0;
    $('.blog__main').innerHTML = '';
    var inputText = $('.blog__search').value.trim().toUpperCase();
    arrArticle.forEach(function (elem) {
      var title = elem.querySelector('.stat__preview__item__text').textContent.trim().toUpperCase();
      if (title.includes(inputText)) {
        count++;
        $('.blog__main').appendChild(elem);
      }
    });
    $(".__cstat").textContent = count;
  };
}
export default function main() {
  $$('img').forEach(function (elem) {
    return elem.setAttribute('draggable', false);
  });
  addViews();
  phoneMask();
  ZayavkaO();
  blogSearch();
  basket();
  start_update_price();
  modelFilter();
  if ($('.search__start')) $('.search__start').onclick = function (e) {
    new SearchModel().open();
    soundPush('/sound/ps5/ps5-gui-sfx.mp3');
  };
  [].forEach.call($$(".order__btm"), function (el) {
    return el.addEventListener("click", function (e) {
      malert.show({
        title: "\u041E\u0442\u043F\u0440\u0430\u0432\u044C\u0442\u0435 \u0437\u0430\u044F\u0432\u043A\u0443",
        text: "\u041F\u0435\u0440\u0435\u0437\u0432\u043E\u043D\u0438\u043C \u0412\u0430\u043C \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 5 \u043C\u0438\u043D\u0443\u0442",
        zayavka: true
        // callback:true,
        // img: `img/icons/info.svg`,
      });
      phoneMask();
      $('.malert .call__input').focus();
    });
  });
  $$('.how__item').forEach(function (el) {
    if (el.querySelector('.how__item__content').classList.contains('active')) {
      var tl = gsap.timeline();
      tl.fromTo(el.querySelector('.how__item__content'), {
        display: 'block',
        y: -40,
        opacity: 0
      }, {
        duration: 0.2,
        opacity: 0.7,
        y: 0
      });
      el.querySelector('.how__item__content').classList.add('active');
    }
    el.querySelector('.how__item__link').addEventListener('click', function (e) {
      var tl = gsap.timeline();
      if (!el.querySelector('.how__item__content').classList.contains('active')) {
        tl.fromTo(el.querySelector('.how__item__content'), {
          display: 'block',
          y: -40,
          opacity: 0
        }, {
          duration: 0.2,
          opacity: 1,
          y: 0
        });
        el.querySelector('.how__item__content').classList.add('active');
      } else {
        tl.fromTo(el.querySelector('.how__item__content'), {
          y: 0,
          opacity: 1
        }, {
          duration: 0.2,
          y: -40,
          opacity: 0,
          display: 'none'
        });
        el.querySelector('.how__item__content').classList.remove('active');
      }
      el.querySelector('.how__item__btm').classList.toggle('active');
    });
  });
  setTimeout(function () {
    if ($('.blog__stat__main') && $('.footer')) $('.footer').classList.add('hidden');else $('.footer').classList.remove('hidden');
  }, 0);
  if ($('.chose__device')) $('.chose__device').addEventListener('click', function () {
    var html = $('.device__list').innerHTML;
    html += "<button class=\"card__list__popup__btm __btm video__on hover__o\">\n<span>\u041A\u0430\u043A \u043C\u044B \u0440\u0430\u0431\u043E\u0442\u0430\u0435\u043C?</span>\n<img loading=\"lazy\" class=\"__btm__icon\" src=\"img/icons/icons8_play_button_circled.svg\" title=\"\u0418\u043A\u043E\u043D\u043A\u0430\" alt=\"\u041F\u0435\u0440\u0435\u0439\u0442\u0438\" draggable=\"false\">\n</button>";
    html = "<div class=\"card__list__popup__wrap\">".concat(html, "</div>");
    malert.show({
      title: "\u041A\u0430\u043A\u043E\u0435 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u043F\u043E\u0447\u0438\u043D\u0438\u0442\u044C?",
      html: html
    });
    $$('.malert-item .card__item').forEach(function (element) {
      sound_hover(element);
      element.addEventListener('click', function (e) {
        var url = element.getAttribute('data-url');
        barba.go(url);
        malert.hide();
      });
    });
    if ($(".video__on ")) $(".video__on ").onclick = function (e) {
      malert.show({
        html: "<div class=\"promo__video cards__theme loaded\" data-lazy-video=\"video/promo-gif-backup.mp4\" data-controls=\"true\" data-speed=\"1\">\n      <video preload=\"auto\" controls=\"\" playsinline=\"\" poster=\"\" muted=\"\" autoplay=\"true\" type=\"video/mp4\" crossorigin=\"anonymous\" loop=\"\">\n      <source src=\"video/promo-gif-backup.mp4\">\n      </video></div>"
      });
    };
  });
  $$('a').forEach(function (elem) {
    return sound_hover(elem);
  });
  $$('.hover__o').forEach(function (elem) {
    return sound_hover(elem);
  });
  $$('.hover__scale').forEach(function (elem) {
    return sound_hover(elem);
  });
}